import React from "react";

const tabs = [
  { key: "raisonSociale", label: "Raison Sociale" },
  { key: "signatureDesStatus", label: "Signature des Statuts" },
  { key: "laSociété", label: "La Société" },
  { key: "adresseDuSiegeSocial", label: "Adresse du Siège Social" },
  { key: "laGérance", label: "La Gérance" },
];

interface TabsNavigationProps {
  activeTab: string;
  onTabClick?: (key: string) => void; 
}

const TabsNavigation: React.FC<TabsNavigationProps> = ({ activeTab, onTabClick }) => {
  return (
    <div className="container my-3">
      <ul className="nav nav-underline">
        {tabs
          .filter((t) => t.key === activeTab) 
          .map((t) => (
            <li className="nav-item" key={t.key}>
              <a
                href={`#${t.key}`}
                className="nav-link active"
                onClick={(e) => {
                  e.preventDefault();
                  onTabClick && onTabClick(t.key);
                }}
              >
                {t.label}
              </a>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default TabsNavigation;
